import { ChannelLineupLayout } from '../types'

export interface ChannelLineupTableProps {
  channelLineupLayout: ChannelLineupLayout
  channelCheckmarkIcon?: string
  channelCheckmarkIconAltText?: string
  optionalChannelLinkText?: string
  viewDetailsLinkText?: string
  viewDetailsModalTitle?: string
  viewDetailsModalPrimaryBtnText?: string
  sortChannelsOptionsTitle?: string
  lineupParams?: {
    [key: string]: any
  }
  lineupData?: {
    [key: string]: any
  }
  loadMoreData?: () => void
}

export enum ChannelLineupTableStatus {
  INIT = 'init',
  APPEND = 'append'
}
